import {
  Popper,
  ClickAwayListener,
  Paper,
  MenuItem,
  Typography,
} from '@mui/material';
import {useRef, useEffect} from 'react';
import AurIcon, {IconNames, IconColors} from '../aur-icon/AurIcon';

interface AurDatePopperProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  handleClose: () => void;
  items: {key: string; value: string}[];
  handleItemClick: (value: string) => void;
  selectedValue: string;
  isValid: boolean;
  errorTextDate?: string;
}

const AurDatePopper: React.FC<AurDatePopperProps> = ({
  open,
  anchorEl,
  handleClose,
  items,
  handleItemClick,
  selectedValue,
  isValid = true,
  errorTextDate = '',
}) => {
  const firstItemRef = useRef<HTMLLIElement | null>(null);

  useEffect(() => {
    if (open && firstItemRef.current) {
      firstItemRef.current.focus();
    }
  }, [open]);

  const selectedMenuItemStyles = {
    backgroundColor: '#2c3a4e',
    '&:hover': {
      backgroundColor: '#2c3a4e',
    },
  };
  return (
    <Popper
      className="date-popper"
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
    >
      <ClickAwayListener onClickAway={handleClose}>
        <Paper
          className="date-paper"
          sx={{
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              width: '16px',
            },
            '&::-webkit-scrollbar-track': {
              marginTop: '2px',
              marginBottom: '2px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#546A8C',
              borderRadius: '100px',
              border: '6px solid transparent',
              backgroundClip: 'content-box',
            },
          }}
        >
          {isValid ? (
            ''
          ) : (
            <Typography className="typo-text body3_size invalid-state-text error-color">
              {errorTextDate}
            </Typography>
          )}
          {items.map((item, index) => {
            const isSelected = item.key === selectedValue;
            return (
              <MenuItem
                className="menu-item"
                key={item.key}
                onClick={() => handleItemClick(item.key)}
                selected={isSelected}
                sx={isSelected ? selectedMenuItemStyles : undefined}
                ref={index === 0 ? firstItemRef : null}
                style={{
                  paddingLeft: '12px',
                  paddingRight: '12px',
                }}
              >
                <Typography variant="body2" className="typo-text body3_size">
                  {item.value}
                </Typography>
                {isSelected && (
                  <AurIcon
                    icon={IconNames.CheckMark}
                    customClassName="check-icon"
                    color={IconColors.Custom}
                  />
                )}
              </MenuItem>
            );
          })}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

export default AurDatePopper;
